import * as z from 'zod'

export const InquiryEmailSchema = z.object({
  name: z.string().min(1, {
    message: 'กรุณาระบุชื่อผู้ติดต่อ',
  }),
  email: z
    .string()
    .email({ message: 'กรุณาระบุอีเมลที่ถูกต้อง' })
    .regex(/^[^\s@]+@[^\s@]+\.[^\s@]+$/, { message: 'กรุณาระบุอีเมลที่ถูกต้อง' }),
  position: z.string().optional(),
  company: z.string().min(1, {
    message: 'กรุณาระบุชื่อบริษัท',
  }),
  phone: z.string()
    .regex(/^\d{10}$/, 'กรุณากรอกหมายเลขโทรศัพท์ 10 หลัก'),
  message: z.string().optional(),
  isAcceptNews: z.boolean().optional(),
})
